import { BaseStore, getOrCreateStore } from '@Di'
import { observable, computed, toJS, action } from 'mobx'

class ExtensionStore extends BaseStore {
  @observable handlers = observable.map()
  @observable activePaths = []
  extensions = []

  constructor() {
    super()
    this.pathData = this.pathData || {}
  }

  @computed
  get activeHeadTags() {
    const { activePaths, handlers } = this
    return activePaths.reduce((acc, k) => {
      const matched = handlers.get(k)
      if (matched) {
        for (const ds of matched.values()) {
          for (const d of ds) {
            const head = d.head
            if (head) {
              Object.keys(head).forEach((tag) => {
                const items = toJS(head[tag])

                if (acc[tag]) {
                  acc[tag] = acc[tag].concat(items)
                } else {
                  acc[tag] = items
                }
              })
            }
          }
        }
      }
      return acc
    }, {})
  }

  getHandlers(path) {
    return this.handlers.get(path)
  }

  getElement(path) {
    const current = this.pathData[path]
    if (current) {
      return current.element
    } else {
      return null
    }
  }

  getData(path) {
    const current = this.pathData[path]
    if (current) {
      return current.data
    } else {
      return null
    }
  }

  @action
  loadExtensions(path, id, extensions) {
    if (!this.handlers.has(path)) {
      this.handlers.set(path, observable.map())
    }
    const byId = this.handlers.get(path)
    byId && byId.set(String(id), extensions.map(createExtension))
  }

  @action
  removeExtensions(path, id) {
    const byId = this.handlers.get(path)
    byId && byId.delete(String(id))
  }

  @action
  activatePath(path, element, data) {
    this.pathData[path] = { element, data }
    this.activePaths.push(path)
  }

  @action
  activateServerPath(path) {
    this.activePaths.push(path)
  }

  @action
  deactivatePath(path) {
    const idx = this.activePaths.findIndex((p) => p === path)
    delete this.pathData[path]
    this.activePaths.splice(idx, 1)
  }
}

function createExtension(ext) {
  return observable(
    {
      match: ext.context,
      head: ext.head,
      context: ext.context,
      onEnter: ext.onEnter,
      onLeave: ext.onLeave,
    },
    {
      context: observable.ref,
      onEnter: observable.ref,
      onLeave: observable.ref,
    }
  )
}

export default getOrCreateStore('ExtensionStore', ExtensionStore)
